import React from "react";
import AdminDisabledField from "features/Admin/components/AdminDisabledField";

const GeneralForm = ({ values }) => (
	<div>
		<AdminDisabledField title="Libellé" value={values.label} />
		<AdminDisabledField title="Analyse active" value={values.status} />
		<AdminDisabledField title="Commentaire" value={values.code_comment} />
		<AdminDisabledField title="Regroupement" value={values.group} />
		<AdminDisabledField title="Mot-clés" value={values.synonyms} />
		<AdminDisabledField title="Sous-traité" value={values.subcontracting} />
		{values.subcontracting && <AdminDisabledField title="Sous-traitant" value={values.subcontracter} />}

		{values.catalog_id > 0 && <AdminDisabledField title="Identifiant dans le catalogue" value={values.catalog_id} />}
		{values.catalog_id > 0 && <AdminDisabledField title="Version" value={values.version} />}
		{values.catalog_id > 0 && values.start_date && <AdminDisabledField title="Date de début" value={values.start_date} />}
		{values.catalog_id > 0 && values.end_date && <AdminDisabledField title="Date de fin" value={values.end_date} />}
	</div>
);

export default GeneralForm;
